module.exports = __webpack_public_path__ + "img/Chagether Yakiniku.7f1d9556.svg";